import { render, staticRenderFns } from "./UploadImage.component.vue?vue&type=template&id=73bd04fb"
import script from "./UploadImage.component.vue?vue&type=script&lang=js"
export * from "./UploadImage.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports